import styled from 'styled-components';

export const Hr = styled.hr.attrs(() => ({
  'aria-hidden': true,
}))<StyleProps>`
  color: ${props => props.theme.colors.background.tertiary};
  opacity: ${props => props.theme.opacities[props.opacity]};
`;

Hr.defaultProps = {
  opacity: 'low',
};
